// extracted by mini-css-extract-plugin
export default {"instructionsWrapper":"instructions_instructionsWrapper__ix73v","instructionsTitle":"instructions_instructionsTitle__ac2r4","cta":"instructions_cta__l9EO+"};